import React from 'react';
import { Outlet } from 'react-router-dom';
import { SAVED_QUERIES_URL_PATH } from './paths';

const SavedQueriesView = React.lazy(() => import('@/views/SavedQueries'));

export default {
  path: SAVED_QUERIES_URL_PATH,
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <SavedQueriesView />,
    },
  ],
};
